import { render } from "./index.vue?vue&type=template&id=e5fc7214"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/campaigns-category-add/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5fc7214"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5fc7214', __exports__)) {
    api.reload('e5fc7214', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=e5fc7214", () => {
    api.rerender('e5fc7214', render)
  })

}


export default __exports__